(() => {
    "use strict";


    // ==========================================================
    // READER
    // ==========================================================

    const reader =
        document.querySelector(
            ".fr-books-chapter"
        ) ||
        document.querySelector(
            ".fr-notebook-note"
        );


    const actionGroups =
        Array.from(
            document.querySelectorAll(
                ".fr-readers-footer"
            )
        );


    if (
        !reader ||
        !actionGroups.length ||
        !window.frMember
    ) {
        return;
    }


    // ==========================================================
    // MOVE ACTIONS INTO READER
    // ==========================================================

    actionGroups.forEach(
        (group) => {
            if (
                !reader.contains(
                    group
                )
            ) {
                reader.appendChild(
                    group
                );
            }
        }
    );


    // ==========================================================
    // ACTION POSITION
    //
    // PAGE MODE:
    //
    //     [ check ]     [ heart ]
    //
    // The two controls are treated as one centered unit.
    // The gap is about half an inch on a normal desktop display.
    //
    // Their vertical position is calculated halfway between:
    //
    // - the top edge of the pseudo-page
    // - the top of the title
    //
    // so changing title spacing does not require another magic
    // top value.
    // ==========================================================

    const ACTION_GAP_PX =
        48;


    function resetActionPosition(
        group
    ) {
        if (
            !group
        ) {
            return;
        }


        const actions =
            group.querySelector(
                ".fr-readers-footer__actions"
            );


        const readButton =
            group.querySelector(
                "[data-log-read]"
            );


        const favoriteButton =
            group.querySelector(
                "[data-toggle-favorite]"
            );


        group.style.position =
            "";

        group.style.inset =
            "";

        group.style.top =
            "";

        group.style.left =
            "";

        group.style.right =
            "";

        group.style.width =
            "";

        group.style.height =
            "";

        group.style.margin =
            "";

        group.style.padding =
            "";

        group.style.pointerEvents =
            "";

        group.style.zIndex =
            "";


        if (
            actions
        ) {
            actions.style.position =
                "";

            actions.style.top =
                "";

            actions.style.left =
                "";

            actions.style.right =
                "";

            actions.style.width =
                "";

            actions.style.height =
                "";

            actions.style.margin =
                "";

            actions.style.padding =
                "";

            actions.style.display =
                "";

            actions.style.alignItems =
                "";

            actions.style.justifyContent =
                "";

            actions.style.gap =
                "";

            actions.style.transform =
                "";

            actions.style.border =
                "";

            actions.style.background =
                "";

            actions.style.pointerEvents =
                "";
        }


        [
            readButton,
            favoriteButton
        ].forEach(
            (button) => {
                if (
                    !button
                ) {
                    return;
                }


                button.style.position =
                    "";

                button.style.top =
                    "";

                button.style.left =
                    "";

                button.style.right =
                    "";

                button.style.transform =
                    "";

                button.style.pointerEvents =
                    "";
            }
        );
    }


    function positionActions() {
        actionGroups.forEach(
            (group) => {
                if (
                    !group
                ) {
                    return;
                }


                resetActionPosition(
                    group
                );


                /*
                 * The special floating treatment belongs to the
                 * pseudo-page only.
                 */
                if (
                    !reader.classList.contains(
                        "fr-books-chapter--page"
                    )
                ) {
                    return;
                }


                const actions =
                    group.querySelector(
                        ".fr-readers-footer__actions"
                    );


                const readButton =
                    group.querySelector(
                        "[data-log-read]"
                    );


                const favoriteButton =
                    group.querySelector(
                        "[data-toggle-favorite]"
                    );


                const title =
                    reader.querySelector(
                        "#fr-books-chapter-title"
                    );


                if (
                    !actions ||
                    !readButton ||
                    !favoriteButton ||
                    !title
                ) {
                    return;
                }


                const readerRect =
                    reader.getBoundingClientRect();


                const titleRect =
                    title.getBoundingClientRect();


                /*
                 * Calculate the midpoint between the page top and
                 * title top in reader-local coordinates.
                 */
                const titleTopInsideReader =
                    titleRect.top -
                    readerRect.top;


                const midpoint =
                    Math.max(
                        48,
                        titleTopInsideReader /
                        2
                    );


                // ----------------------------------------------
                // FOOTER BECOMES A ZERO-SIZE OVERLAY
                // ----------------------------------------------

                group.style.position =
                    "absolute";

                group.style.inset =
                    "0";

                group.style.width =
                    "100%";

                group.style.height =
                    "0";

                group.style.margin =
                    "0";

                group.style.padding =
                    "0";

                group.style.pointerEvents =
                    "none";

                group.style.zIndex =
                    "20";


                // ----------------------------------------------
                // CENTERED ACTION PAIR
                // ----------------------------------------------

                actions.style.position =
                    "absolute";

                actions.style.top =
                    `${midpoint}px`;

                actions.style.left =
                    "50%";

                actions.style.right =
                    "auto";

                actions.style.width =
                    "auto";

                actions.style.height =
                    "auto";

                actions.style.margin =
                    "0";

                actions.style.padding =
                    "0";

                actions.style.display =
                    "flex";

                actions.style.alignItems =
                    "center";

                actions.style.justifyContent =
                    "center";

                actions.style.gap =
                    `${ACTION_GAP_PX}px`;

                actions.style.transform =
                    "translate(-50%, -50%)";

                actions.style.border =
                    "0";

                actions.style.background =
                    "transparent";

                actions.style.pointerEvents =
                    "none";


                // ----------------------------------------------
                // BUTTONS PARTICIPATE IN FLEX LAYOUT
                // ----------------------------------------------

                [
                    readButton,
                    favoriteButton
                ].forEach(
                    (button) => {
                        button.style.position =
                            "static";

                        button.style.top =
                            "auto";

                        button.style.left =
                            "auto";

                        button.style.right =
                            "auto";

                        button.style.transform =
                            "none";

                        button.style.pointerEvents =
                            "auto";
                    }
                );
            }
        );
    }


    // ==========================================================
    // CURRENT WORK
    // ==========================================================

    function getPostId() {
        return String(
            reader.dataset.readerPostId ||
            ""
        ).trim();
    }


    function getReaderTitle() {
        const title =
            document.querySelector(
                "#fr-books-chapter-title"
            )
                ?.textContent
                ?.trim();


        const notebookTitle =
            reader.querySelector(
                "[data-notebook-note-title]"
            )
                ?.textContent
                ?.trim();


        return (
            title ||
            notebookTitle ||
            reader.dataset.readerTitle ||
            ""
        );
    }


    function getReaderBook() {
        const breadcrumbBook =
            document.querySelector(
                "#fr-books-breadcrumb-book"
            )
                ?.textContent
                ?.trim();


        return (
            breadcrumbBook ||
            reader.dataset.readerBook ||
            ""
        );
    }


    function getReaderUrl() {
        return (
            reader.dataset.readerUrl ||
            window.location.href
        );
    }


    function getReaderPageCount() {
        const content =
            document.querySelector(
                "#fr-books-chapter-content"
            ) ||
            reader.querySelector(
                "[data-notebook-note-content]"
            );


        if (
            !content
        ) {
            return 1;
        }


        const wordCount =
            String(
                content.textContent ||
                ""
            )
                .trim()
                .split(
                    /\s+/
                )
                .filter(
                    Boolean
                )
                .length;


        return Math.max(
            1,
            Math.ceil(
                wordCount /
                250
            )
        );
    }


    function getFavoriteMetadata() {
        return {
            title:
                getReaderTitle(),

            book:
                getReaderBook(),

            url:
                getReaderUrl(),

            pages:
                getReaderPageCount()
        };
    }


    // ==========================================================
    // STATE
    // ==========================================================

    function getReadCount() {
        const postId =
            getPostId();


        if (
            !postId
        ) {
            return 0;
        }


        return Number(
            window.frMember.getReadCount(
                postId
            )
        ) || 0;
    }


    function getFavoriteState() {
        const postId =
            getPostId();


        if (
            !postId
        ) {
            return false;
        }


        return Boolean(
            window.frMember.isFavorite(
                postId
            )
        );
    }


    // ==========================================================
    // RENDER ONE ACTION GROUP
    // ==========================================================

    function renderActionGroup(
        group,
        {
            postId,
            readCount,
            favorite
        }
    ) {
        if (
            !group
        ) {
            return;
        }


        const readButton =
            group.querySelector(
                "[data-log-read]"
            );


        const readCountElement =
            group.querySelector(
                "[data-read-count]"
            );


        const readLabelElement =
            group.querySelector(
                "[data-read-label]"
            );


        const favoriteButton =
            group.querySelector(
                "[data-toggle-favorite]"
            );


        if (
            !readButton ||
            !favoriteButton
        ) {
            return;
        }


        // ------------------------------------------------------
        // NO CURRENT POST
        // ------------------------------------------------------

        if (
            !postId
        ) {
            readButton.hidden =
                true;

            favoriteButton.hidden =
                true;

            return;
        }


        readButton.hidden =
            false;

        favoriteButton.hidden =
            false;


        // ------------------------------------------------------
        // READ
        // ------------------------------------------------------

        const hasBeenRead =
            readCount >
            0;


        readButton.classList.toggle(
            "is-read",
            hasBeenRead
        );


        readButton.classList.toggle(
            "is-active",
            hasBeenRead
        );


        readButton.setAttribute(
            "aria-pressed",
            String(
                hasBeenRead
            )
        );


        readButton.setAttribute(
            "aria-label",
            hasBeenRead
                ? `Read ${readCount} ${
                    readCount === 1
                        ? "time"
                        : "times"
                }. Mark as read again.`
                : "Mark this piece as read"
        );


        readButton.title =
            hasBeenRead
                ? `Read ${readCount} ${
                    readCount === 1
                        ? "time"
                        : "times"
                }`
                : "Mark as read";


        /*
         * IMPORTANT:
         *
         * Do NOT put a checkmark in these hidden legacy spans.
         * The SVG inside the button is the one and only visible
         * checkmark.
         */

        if (
            readCountElement
        ) {
            readCountElement.textContent =
                String(
                    readCount
                );

            readCountElement.hidden =
                true;

            readCountElement.style.display =
                "none";
        }


        if (
            readLabelElement
        ) {
            readLabelElement.textContent =
                readCount ===
                1
                    ? "time"
                    : "times";

            readLabelElement.hidden =
                true;

            readLabelElement.style.display =
                "none";
        }


        // ------------------------------------------------------
        // FAVORITE
        // ------------------------------------------------------

        const favoriteDisabled =
            readCount <
            1;


        favoriteButton.classList.toggle(
            "is-favorite",
            favorite
        );


        favoriteButton.classList.toggle(
            "is-active",
            favorite
        );


        favoriteButton.classList.toggle(
            "is-disabled",
            favoriteDisabled
        );


        favoriteButton.disabled =
            favoriteDisabled;


        favoriteButton.setAttribute(
            "aria-disabled",
            String(
                favoriteDisabled
            )
        );


        favoriteButton.setAttribute(
            "aria-pressed",
            String(
                favorite
            )
        );


        favoriteButton.setAttribute(
            "aria-label",
            favoriteDisabled
                ? "Read this piece before adding it to favorites"
                : favorite
                    ? "Remove from favorites"
                    : "Add to favorites"
        );


        favoriteButton.title =
            favoriteDisabled
                ? "Read this piece before favoriting"
                : favorite
                    ? "Remove from favorites"
                    : "Favorite";
    }


    // ==========================================================
    // RENDER ALL
    // ==========================================================

    function render() {
        const postId =
            getPostId();


        const readCount =
            postId
                ? getReadCount()
                : 0;


        const favorite =
            postId
                ? getFavoriteState()
                : false;


        actionGroups.forEach(
            (group) => {
                renderActionGroup(
                    group,
                    {
                        postId,
                        readCount,
                        favorite
                    }
                );
            }
        );


        requestAnimationFrame(
            positionActions
        );
    }


    // ==========================================================
    // READ CLICK
    // ==========================================================

    function handleReadClick() {
        const postId =
            getPostId();


        if (
            !postId
        ) {
            return;
        }


        window.frMember.logRead(
            postId
        );


        render();
    }


    // ==========================================================
    // FAVORITE CLICK
    // ==========================================================

    function handleFavoriteClick() {
        const postId =
            getPostId();


        if (
            !postId
        ) {
            return;
        }


        if (
            getReadCount() <
            1
        ) {
            return;
        }


        window.frMember.toggleFavorite(
            postId,
            getFavoriteMetadata()
        );


        render();
    }


    // ==========================================================
    // CONNECT CONTROLS
    // ==========================================================

    actionGroups.forEach(
        (group) => {
            const readButton =
                group.querySelector(
                    "[data-log-read]"
                );


            const favoriteButton =
                group.querySelector(
                    "[data-toggle-favorite]"
                );


            readButton?.addEventListener(
                "click",
                handleReadClick
            );


            favoriteButton?.addEventListener(
                "click",
                handleFavoriteClick
            );
        }
    );


    // ==========================================================
    // READER CHANGES
    // ==========================================================

    const observer =
        new MutationObserver(
            () => {
                render();
            }
        );


    observer.observe(
        reader,
        {
            attributes:
                true,

            attributeFilter: [
                "data-reader-post-id",
                "data-reader-title",
                "data-reader-book",
                "data-reader-url",
                "class"
            ]
        }
    );


    // ==========================================================
    // WINDOW EVENTS
    // ==========================================================

    window.addEventListener(
        "resize",
        () => {
            requestAnimationFrame(
                positionActions
            );
        }
    );


    window.addEventListener(
        "storage",
        render
    );


    window.addEventListener(
        "fr-books-quote-favorites-changed",
        render
    );


    // ==========================================================
    // INITIALIZE
    // ==========================================================

    render();

})();